import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { sponsorsRoute } from '.'

const Sponsors = lazyRouteComponent(() => import('../../pages/sponsors/sponsors'))

export const sponsorsListRoute = createRoute({
  getParentRoute: () => sponsorsRoute,
  path: '/',
  component: Sponsors,
})
